import getFormattedClassnames from 'utils/getFormattedClassnames';
import camelCaseString from 'utils/camelCaseString';

/**
 * Get a component's hashed classname.
 *
 * @param {String} className The classname to retrieve.
 * @param {String} component The component from which to retrieve the classname.
 *
 * @return {String|Boolean} The classname, or false if not found.
 */
export default function getClassnameFromComponent(className, component) {
  // Format the string to match that of the classnames object.
  const camelcasedClassName = camelCaseString(className);

  // Get the formatted classname.
  const navBarClassnames = sciencenewsClassnames[component];
  const navBarSelectors = getFormattedClassnames(navBarClassnames);

  return (undefined !== navBarSelectors[camelcasedClassName])
    ? navBarSelectors[camelcasedClassName]
    : false;
}
